import { render, staticRenderFns } from "./KassaFlow.vue?vue&type=template&id=b8395a38&scoped=true"
import script from "./KassaFlow.vue?vue&type=script&lang=js"
export * from "./KassaFlow.vue?vue&type=script&lang=js"
import style0 from "./KassaFlow.vue?vue&type=style&index=0&id=b8395a38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8395a38",
  null
  
)

export default component.exports